import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Disable background scroll when mobile menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about-us' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    // <nav
    //   className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300
    //     ${location.pathname === '/'
    //       ? (scrolled ? 'bg-[#011321] shadow-md' : 'bg-transparent')
    //       : 'bg-[#011321] shadow-md'
    //     }
    //   `}
    // >
    <nav
      className="fixed top-0 left-0 right-0 z-50 bg-[#FFFFFF]  shadow-md transition-all duration-300 border-b-4 border-black"
    >

      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> */}
      <div className="max-w-8xl pe-6">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}

          {!isMobile && (



            <div className='flex ps-4'>
              <Link to="/" className="flex items-center focus:outline-none focus:ring-0">
                <div className=" flex items-center">
                  <img
                    src="/aaj-home/AAJ LOGO (1).jpeg"
                    alt="aaj engineers logo"
                    className="h-20 w-44 object-contain"
                  />


                </div>
              </Link>
            </div>
          )}

          {isMobile && (

            <div className='flex ps-4'>
              <Link to="/" className="flex items-center focus:outline-none focus:ring-0">
                <div className=" flex items-center ">
                  <img
                    src="/aaj-home/AAJ LOGO (1).jpeg"
                    alt="aaj engineers logo"
                    className="h-20 w-44 object-contain"
                  />

                </div>
              </Link>
             
            </div>
          )}


          {/* Desktop Navigation */}
          <div className="hidden xl:flex  items-center space-x-6">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`relative px-0 py-1 font-medium transition focus:outline-none focus:ring-0 text-xl
                  ${isActive(item.path)
                    ? 'text-[#00B9F1] font-semibold'
                    : 'text-[#011321] hover:text-[#00B9F1]'
                  }
                `}
              >
                <span>{item.name}</span>
                {isActive(item.path) && (
                  <span className="absolute -bottom-1 left-0 w-full h-[2px] bg-[#00B9F1] rounded-full"></span>
                )}
              </Link>
            ))}
          
          </div>


          {/* Mobile menu button */}
          <div className="xl:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className={`p-3 rounded-xl transition-colors focus:outline-none focus:ring-0
                ${location.pathname === '/'
                  ? (scrolled ? 'text-[#011321]' : 'bg-white/10 backdrop-blur-sm text-[#011321] border border-white/20')
                  : ' text-[#011321]'
                }
              `}
            >
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>


        </div>
        {/* <div className="ml-1">
                 <img
                    src="/images/WhatsApp Image 2025-09-13 at 16.54.10_b60a3e66.jpg"
                    alt="Logo"
                   className="w-20 h-20 md:w-27 md:h-27 lg:w-27 lg:h-27 object-full drop-shadow-lg rounded-full p-1"
                  />
              
            </div> */}

        {/* Mobile Navigation - Small menu */}
        {isOpen && (
          <div className="fixed inset-0 z-50 flex flex-col pt-6 bg-[#2a5298] overflow-y-auto">
            {/* Close Button */}
            <div className="flex justify-end px-6">
              <button
                onClick={() => setIsOpen(false)}
                className="p-2 rounded-full bg-white text-[#2a5298] focus:outline-none"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            {/* Menu Items */}
            <div className="flex flex-col mt-4 mb-6">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`block px-6 py-3 mx-4 my-1 rounded-lg transition
        ${isActive(item.path)
                      ? 'bg-[#011321] text-white font-semibold'
                      : 'text-white hover:bg-white/20 hover:text-white'
                    }`}
                >
                  {item.name}
                </Link>
              ))}

              {/* Career only in Menu */}
              {/* <Link
                to="/career"
                onClick={() => setIsOpen(false)}
                className={`block px-6 py-3 mx-4 my-1 rounded-lg transition
      ${isActive('/career')
                    ? 'bg-[#011321] text-white font-semibold'
                    : 'text-white hover:bg-white/20 hover:text-white'
                  }`}
              >
                Career
              </Link> */}
            </div>

          </div>
        )}

      </div>
    </nav>
  );
};

export default Navbar;
